import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer, Tooltip } from 'recharts';
import { useMemo } from 'react';

export default function WellnessRadarProfile({ individualTrends, title }) {
  const profileData = useMemo(() => {
    if (!individualTrends || individualTrends.length === 0) return [];
    const recent = individualTrends.slice(-7);
    const avg = (key) => recent.reduce((s, d) => s + (d[key] || 0), 0) / recent.length;
    return [
      { metric: 'Mood', value: +avg('mood').toFixed(1), fullMark: 10 },
      { metric: 'Energy', value: +avg('energy').toFixed(1), fullMark: 10 },
      { metric: 'Confidence', value: +avg('confidence').toFixed(1), fullMark: 10 },
      { metric: 'Focus', value: +avg('focus').toFixed(1), fullMark: 10 },
      { metric: 'Sleep', value: +avg('sleep_quality').toFixed(1), fullMark: 10 },
      { metric: 'Performance', value: +avg('performance_rating').toFixed(1), fullMark: 10 },
      { metric: 'Low Stress', value: +(10 - avg('stress')).toFixed(1), fullMark: 10 },
    ];
  }, [individualTrends]);

  if (profileData.length === 0) return null;

  const overall = (profileData.reduce((s, d) => s + d.value, 0) / profileData.length).toFixed(1);

  return (
    <div data-testid="wellness-radar-profile" className="bg-white rounded-xl shadow-lg p-6 border border-emerald-100">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-lg font-bold text-gray-900">{title || 'Wellness Profile'}</h2>
        <div className="text-right">
          <span className="text-2xl font-bold text-emerald-600">{overall}</span>
          <span className="text-sm text-gray-500">/10</span>
          <p className="text-[10px] text-gray-400">7-day average</p>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={280}>
        <RadarChart cx="50%" cy="50%" outerRadius="72%" data={profileData}>
          <PolarGrid stroke="#d1d5db" />
          <PolarAngleAxis dataKey="metric" tick={{ fontSize: 11, fill: '#374151', fontWeight: 600 }} />
          <PolarRadiusAxis angle={90} domain={[0, 10]} tick={{ fontSize: 9, fill: '#9ca3af' }} tickCount={3} />
          <Tooltip
            content={({ active, payload }) => {
              if (!active || !payload?.length) return null;
              const d = payload[0].payload;
              return (
                <div className="bg-white rounded-lg shadow-lg border px-3 py-2 text-xs">
                  <p className="font-bold text-gray-900">{d.metric}</p>
                  <p className="text-emerald-600">{d.value} / 10</p>
                </div>
              );
            }}
          />
          <Radar dataKey="value" stroke="#059669" fill="#10b981" fillOpacity={0.25} strokeWidth={2} dot={{ r: 4, fill: '#059669' }} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
